module.exports = __webpack_public_path__ + "img/home_code.818a3724.jpg";